import { CustomerDetails, CustomerFormData } from '../types/CustomerTypes';
import { useGetCustomerQuery, useUpdateCustomerMutation } from '@/common/infrastructure/gql/generated/schema';

import { mapFormDataToUpdateInput } from '../mappers/CustomerMappers';

export const useUpdateCustomer = (customerId: number) => {
  const hasCustomerId = typeof customerId === 'number' && Number.isFinite(customerId) && customerId > 0;

  const [updateCustomer, { data, loading, error }] = useUpdateCustomerMutation();
  const { data: customerData } = useGetCustomerQuery({
    variables: { customerId: customerId as number },
    skip: !hasCustomerId
  });

  const handleUpdateCustomer = async (formData: CustomerFormData) => {
    try {
      const customerDetails = customerData?.customerDetails as CustomerDetails | null;
      const customer = customerDetails ?? undefined;
      const mutationInput = mapFormDataToUpdateInput(formData, customer);
      await updateCustomer({
        variables: { customer: mutationInput },
        refetchQueries: ['listCustomers', 'getCustomer'],
        awaitRefetchQueries: true
      });
    } catch (err) {
      console.error('Error updating customer:', err);
      throw err;
    }
  };

  return { handleUpdateCustomer, data, loading, error };
};
